/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  EstimationItemCostResponse,
  UpsertEstimationItemCostRequest,
  V1EstimationItemsCostsListError,
  V1EstimationItemsCostsUpdateError,
  V1EstimationsEstimationItemCostsListError,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class EstimationItemCost<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags EstimationItemCost
   * @name V1EstimationsEstimationItemCostsList
   * @request GET:/api/v1/estimations/{estimationId}/estimation-item-costs
   * @secure
   * @response `200` `(EstimationItemCostResponse)[]` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsEstimationItemCostsList = (estimationId: string, params: RequestParams = {}) =>
    this.http.request<EstimationItemCostResponse[], V1EstimationsEstimationItemCostsListError>({
      path: `/api/v1/estimations/${estimationId}/estimation-item-costs`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EstimationItemCost
   * @name V1EstimationItemsCostsList
   * @request GET:/api/v1/estimation-items/{estimationItemId}/costs
   * @secure
   * @response `200` `(EstimationItemCostResponse)[]` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationItemsCostsList = (estimationItemId: string, params: RequestParams = {}) =>
    this.http.request<EstimationItemCostResponse[], V1EstimationItemsCostsListError>({
      path: `/api/v1/estimation-items/${estimationItemId}/costs`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EstimationItemCost
   * @name V1EstimationItemsCostsUpdate
   * @summary Updates or creates all estimation item costs of estimation item.
   * @request PUT:/api/v1/estimation-items/{estimationItemId}/costs
   * @secure
   * @response `200` `(EstimationItemCostResponse)[]` OK
   * @response `400` `ProblemDetailsWithErrorCode` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationItemsCostsUpdate = (
    estimationItemId: string,
    data: UpsertEstimationItemCostRequest[],
    params: RequestParams = {},
  ) =>
    this.http.request<EstimationItemCostResponse[], V1EstimationItemsCostsUpdateError>({
      path: `/api/v1/estimation-items/${estimationItemId}/costs`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
